import { Box, Button, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import QuickPay from "../../assets/QuickPay.svg";
import DealsTable from '../../components/DealsTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../Redux/reducer';
import { setCivilIdAction } from '../../Redux/actions';
import { useEffect, useState } from 'react';
import KuwaitiDinarFormat from '../../components/KuwaitiDinarFormat';
import { apiURL } from '../../constants/apiUrlConstants';
import IdleTimerContainer from '../../components/IdleTimerContainer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InfoIcon from '@mui/icons-material/Info';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getEmailStatus } from '../../utils/emailStatus';
import { clearSessionStorage, getNewToken, postRequest } from '../../services/httpservice';
import axios, { AxiosError } from 'axios';
import Loader from '../../components/Loader';
import Tooltip from '@mui/material/Tooltip';
const Deals = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [civilId, setLocalCivilId] = useState<string | null>(null);
  const civilIdStore = useSelector((state: RootState) => state.civilId);
  const navigate = useNavigate();
  const location = useLocation();
  const [quickPayAmount, setQuickPayAmount] = useState(0);
  const loanAccountNumbers = useSelector((state: RootState) => state.loanAccountNumbers);
  const [customerNo, setCustomerNo] = useState<string | null>(null);
  const [isEmailExist, setIsEmailExist] = useState<boolean>(true);
  const [toastCloseInMs, setToastCloseInMs] = useState<number>(0);
  const [isLoading, setIsloading] = useState<boolean>(false)
  const [name, setName] = useState<string>('');
  const [nameArabic, setNameArabic] = useState<string>('');
  let isFirstTime = true;
  useEffect(() => {
    const name = sessionStorage.getItem('name');
    const nameArabic = sessionStorage.getItem('nameArabic');
    if(name) {
        setName(name);
    }
    if(nameArabic!== null && nameArabic!== "" && nameArabic!== undefined && nameArabic!== "null") {
      if(name!== null && name!== "" && name!== undefined && name!== "null") {
        setName(name +" / ");
    }
      setNameArabic(nameArabic);
    }
    const msToast = process.env.REACT_APP_TOAST_CLOSE_IN_SECONDS;
    if(msToast) {
        setToastCloseInMs(parseInt(msToast));
    }
    const urlParams = new URLSearchParams(location.search);
    const tempshortLink = urlParams.get('t');
    if (tempshortLink !== null) {
      if(isFirstTime) {
        getTokenByShortLink(tempshortLink);
      }
    }else {
      const storedCivilId = sessionStorage.getItem('civilId');
      if (storedCivilId) {
        setLocalCivilId(storedCivilId);
        dispatch(setCivilIdAction(storedCivilId));
      } else if (civilIdStore) {
        setLocalCivilId(civilIdStore);
      }
    }
  },[]);

  const handleQuickPayAmountChange = (amount: number) => {
    setQuickPayAmount(amount);
  };

  const handleCustomerNumberChange = (customerNumber: string) => {
    setCustomerNo(customerNumber);
  };

  // const handleQuickPay = async () => {
  //   try {
  //     const accessToken = sessionStorage.getItem('accessToken');
  //     if (!accessToken) {
  //       clearSessionStorage();
  //       navigate('/');
  //       return;
  //     }

     
  //     setIsloading(true);
  //     const response = await postRequest(
  //       process.env.REACT_APP_API_URL + apiURL.CHECK_OUT_DETAILS, {
  //       totalAmount: quickPayAmount,
  //       civilId: civilId,
  //       loanAccountNumbers: loanAccountNumbers,
  //       customerNo: customerNo,
  //       quickPayYn: "Y"
  //     }
  //     );
  //     setIsloading(false);
  //     if(response=== null) {
  //       toast.dismiss();
  //       toast.error(process.env.REACT_APP_ERROR_MSG);
  //       return;
  //     }
  //     if (response.status == 401) {
  //       toast.error('Session expired');
  //       clearSessionStorage();
  //       setTimeout(() => {
  //         navigate('/');
  //       }, 2000);
  //       return;
  //     }
  //     if(response.data=== '') {
  //         toast.dismiss();
  //         toast.error(process.env.REACT_APP_ERROR_MSG);
  //         return;
  //     }
  
  //     const data = response.data;
  //     if(data !=null) {
  //       if (data.isSuccess) {
  //         getNewToken();
  //         window.location.href = data.checkout_url;
  //       } else {
  //         if(data.message === null || data.message === "" || data.message === undefined) {
  //           toast.error('No Late Installment is Available Against Logged Civil Id.');
  //         }else {
  //           toast.error(`${data.message}`);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     setIsloading(false);
  //     if (axios.isAxiosError(error)) {
  //       const axiosError = error as AxiosError;
  //       if (axiosError.response) {
  //         if (axiosError?.response.status == 401) {
  //           toast.error('Session expired');
  //           clearSessionStorage();
  //           setTimeout(() => {
  //             navigate('/');
  //           }, 2000);
  //         }else {
  //           toast.error(process.env.REACT_APP_ERROR_MSG);
  //         }
  //       }
  //     }
  //   }
  // }

  const getTokenByShortLink = async (shortLinkKey: string) => {
    if (shortLinkKey === null || shortLinkKey === undefined || shortLinkKey === "") {
      return;
    }
    isFirstTime = false;
    try {
      const response = await postRequest(
        process.env.REACT_APP_API_URL + apiURL.GET_TOKEN_BY_SHORT_LINK, {
          shortLinkKey: shortLinkKey,
      }
      );
      if (response == null) {
        toast.dismiss();
        toast.error(process.env.REACT_APP_ERROR_MSG);
       return;
        }
        if (response.status === 401) {
          toast.error('Session expired');
          clearSessionStorage();
          setTimeout(() => {
            navigate('/');
          }, 2000);
          return;
        }
        if(response.data=== '') {
            toast.dismiss();
            toast.error(process.env.REACT_APP_ERROR_MSG);
            return;
        }

     
      const data = response.data;
      if (data !== null && data !== undefined && data !== "") {
        if(!data.success) {
          clearSessionStorage();
          navigate('/');
          return;
        }
        const token = data.token;
        if (token !== null) {
          sessionStorage.setItem('accessToken', token);
        }
        if (data.civilId !== null) {
          sessionStorage.setItem('civilId', data.civilId);
          sessionStorage.setItem('name', data.name);
          sessionStorage.setItem('nameArabic', data.nameArabic);
          setLocalCivilId(data.civilId);
          const name = sessionStorage.getItem('name');
          const nameArabic = sessionStorage.getItem('nameArabic');
          if(name) {
              setName(name);
          }
          if(nameArabic!== null && nameArabic!== "" && nameArabic!== undefined && nameArabic!== "null") {
            if(name!== null && name!== "" && name!== undefined && name!== "null") {
              setName(name +" / ");
          }
            setNameArabic(nameArabic);
          }
        }
        if (data.email !== null && data.email !== undefined && data.email !== "") {
          setTimeout(() => {
            setIsEmailExist(true);
          }, 1000);
          sessionStorage.setItem('isEmail', "true");
        } else {
          setIsEmailExist(false);
        }
      } else {
        setIsEmailExist(false);
      }

    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.dismiss();
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          // console.log("Error while fetching user profile");
          if (axiosError?.response.status == 401) {
            toast.error('Session expired');
            clearSessionStorage();
            setTimeout(() => {
              navigate('/');
            }, 2000);
          }else {
            toast.error(process.env.REACT_APP_ERROR_MSG);
        }
        }
      } else {
        // console.log("Unknown error:", error);
      }
    }
  }

  return (
    <>
    {isLoading && <Loader />}
      <Container className='dealsContainer mainContainer' maxWidth="xl" sx={{ mt: { xs: 24, sm: 4 } }}>
        {/* {(!getEmailStatus() || !isEmailExist) && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            background: '#FDEDED',
            color: '#5F2120',
            fontSize: 'small',
            px: 1,
            py: 2.5,
            mt: 10,
            mb: 3,

            borderRadius: 1
          }}>
            <InfoIcon style={{ marginLeft: '20px' }} />
            <span style={{ marginLeft: '8px', fontWeight: "bolder", fontSize: "1.2rem" }}>  الإلكتروني بريدك تسجيل يرجى تقلق، لا .سجلاتنا في بك الخاص الإلكتروني البريد على العثور من نتمكن لم أننا يبدو.
            <br/>It seems like we couldn't find your email ID in our records. No worries, please take a moment to register your email. <span className='clickHereLink'><Link style={{ color: '#0067B2', textDecoration: 'none' }} to={`/home/profile`}>Click Here.</Link></span></span>
          </Box>
        )} */}

        <Box>
          <Box className="headerSubheaderStyle headerColor headerBgColor" sx={{ px: 5 }}>
            <Box className="dealTitle pad-right-10" > {t('deals.dealDetails')} <br/>  </Box>
          {/* <Box className="trns-HeaderTitle" sx={{ fontSize: { xs: '0.9rem', sm: '1.2rem' } }}> {name}<span dir="rtl" lang="ar" className='pad-right-10'>{nameArabic}</span> </Box> */}
            <Box className="civilId"> {t('deals.civilId')}<span dir="rtl" lang="ar" > - </span>{civilId} </Box>
          </Box>
          <Box
            className="dealsheaderSubheaderStyle subheaderBgColor"
            sx={{
              px: 5,
              display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: { xs: 'flex-end', sm: 'flex-end', md: 'space-between' },
              alignItems: { xs: 'center', md: 'center' },
              height: '100%'
            }}>
            <Box className="dealsSelectTitle"
              sx={{
                fontSize: { xs: '16px', md: '18px' },
                mt: 2
              }}>
              {t('deals.selectDeal')} <br/>
            </Box>
             </Box>
            <Box className="trns-tableDiv"     sx={{
              
              display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: { xs: 'flex-end', sm: 'flex-end', md: 'space-between' },
              alignItems: { xs: 'center', md: 'center' },
              height: '100%',

    py: 0,        
  
            }}>
              <div
                className="text-left  mb-2"
              
              >
                <small>
              {t("deals.paymentUpdateNote")}{" "}
  <Link to="/home/transactions" style={{ color: "#2A92BD", textDecoration: "underline " }}>
    <b>{t("deals.click")}</b>
  </Link>
                </small>
              </div>
            </Box>
       
          <Box className="dealsTable-container" sx={{ padding: { xs: '25px 30px', md: '0px 40px 25px 40px;' } ,   pt: 0, }}>
            <DealsTable
               civilId={civilId}
               onQuickPayAmountChange={handleQuickPayAmountChange}
               onCustomerNumberChange={handleCustomerNumberChange}
            />
          </Box>
        </Box>
        <ToastContainer
          position="top-right"
          newestOnTop
          limit={1}
          autoClose={toastCloseInMs}
        />
        <IdleTimerContainer />
      </Container>
    </>
  );

}
export default Deals;